<template>
    <el-dialog title="上架推送平台" :visible.sync="_visible" width="500px">
        <el-form ref="form" label-width="70px" :model="ruleForm" class="dialog-Form" :rules="rules">
            <el-form-item label="文件标题:" prop="title">
                <el-input v-model="ruleForm.title" clearable disabled></el-input>
            </el-form-item>
            <el-form-item label="文件描述:" prop="subDescribe">
                <el-input type="textarea" :rows="4" maxlength="500" show-word-limit
                    v-model="ruleForm.subDescribe" placeholder="输入500字以内的文件描述内容" clearable
                    disabled></el-input>
            </el-form-item>
            <el-form-item label="标签信息:" prop="dictCodeList">
                <el-select style="width:100%" v-model="ruleForm.dictCodeList" clearable multiple
                    placeholder="请选择标签信息" popper-class="tagInfo" :popper-append-to-body="false">
                    <el-option v-for="(item) in dictData" :key="item.dictCode"
                        :label="item.dictLabel" :value="item.dictCode"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="情报类型:" prop="subCatId">
                <el-select style="width:100%" v-model="ruleForm.subCatId" clearable
                    placeholder="请选择情报类型" popper-class="tagInfo" :popper-append-to-body="false">
                    <el-option v-for="(item) in subclass" :key="item.id" :label="item.subCatName"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <div class="number">
                <el-form-item label="发布期数:" prop="particularYear" class="year">
                    <el-date-picker v-model="ruleForm.particularYear" type="year" placeholder="选择年"
                        value-format="yyyy">
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="subNumber" class="num">
                    <el-input v-model="ruleForm.subNumber"><span slot="suffix">期</span></el-input>
                </el-form-item>
            </div>
            <el-form-item label="发布类型:" prop="releaseType">
                <el-radio v-model="ruleForm.releaseType" label="0">免费公开</el-radio>
                <el-radio v-model="ruleForm.releaseType" label="1">付费订阅</el-radio>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="_visible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="onSubmit" :loading='loading'>确
                定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { addSubIntelligence } from "@/network/content/artice";
export default {
    name: "subForm",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        dictData: {
            type: Array,
            default: () => {
                return []
            }
        },
        subclass: {
            type: Array,
            default: () => {
                return []
            }
        },
        ruleForm: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        var validateSubNumber = (rule, value, callback) => {
            let reg = /^([1-9][0-9]{0,8}|2147483647)$/;
            if (value === '') {
                // callback(new Error('请输入期数'));
                callback();
            }
            if (reg.test(value)) {
                callback();
            } else {
                if (value > 2147483647) {
                    callback(new Error('期数不能大于2147483647'));

                } else {
                    callback(new Error('请输入大于0的正整数'));
                }
            }
        };
        return {
            rules: {
                title: [{
                    required: true,
                    message: '请输入文件标题',
                    trigger: 'change'
                },
                { min: 1, max: 50, message: '长度50 个字符以内', trigger: 'change' }
                ],
                dictCodeList: [{
                    required: true,
                    message: '请选择标签信息',
                    trigger: 'blur'
                }],
                subCatId: [{
                    required: true,
                    message: '请选择情报类型',
                    trigger: 'blur'
                }],
                particularYear: [{
                    required: true,
                    message: '请输入期刊年份',
                    trigger: 'blur'
                }],
                subDescribe: [{
                    required: true,
                    message: '请输入文件描述',
                    trigger: 'blur'
                }],
                subNumber: [{
                    required: true,
                    validator: validateSubNumber,
                    trigger: 'change'
                }
                ],
                releaseType: [{
                    required: true,
                    message: '请选择发布类型',
                    trigger: 'change'
                }],
            },
            loading: false
        };
    },
    computed: {
        _visible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit("update:visible", val);
            },
        },
    },
    methods: {
        onSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    addSubIntelligence(this.ruleForm)
                        .then((res) => {
                            if (res.data.code == 200) {
                                this._visible = false
                                this.$message.success(res.data.msg)
                            }
                            this.loading = false
                        })
                        .catch((err) => { });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .tagInfo {
    .el-select-dropdown__list {
        display: flex;
        flex-wrap: wrap;
        width: 500px;
    }
}
.number {
    width: 100%;
    display: flex;
    .year {
        flex: 8;
        .el-date-editor {
            width: 100%;
        }
    }

    .num {
        flex: 4;
        margin-left: 10px;
        ::v-deep .el-form-item__content {
            margin-left: 0px !important;
        }
    }
}
</style>
